import React, { ReactElement } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { commonStyles } from "./commonStyles";

const Loader = ({ isWhite }: { isWhite?: boolean }): ReactElement => {
  return (
    <CircularProgress
      sx={{ color: isWhite ? "white" : commonStyles.cpaGold }}
    />
  );
};

export default Loader;
